import script from "./Case.vue?vue&type=script&lang=ts&setup=true"
export * from "./Case.vue?vue&type=script&lang=ts&setup=true"

import "./Case.vue?vue&type=style&index=0&id=3a8a3866&lang=less"

const __exports__ = script;

export default __exports__